import Ad from '@/components/Molecules/Ad';
import { classMerge } from '@/utils/class-names';
import { AdSlotSize, IAdSlotSizeMap } from 'types/Ads';

import { SidebarAdComponent } from './types';

const SidebarAd: SidebarAdComponent = ({
	adUnit,
	className,
	isSticky,
	id = adUnit,
}) => {
	const sizes: AdSlotSize[] = [
		[300, 600],
		[300, 250],
		[160, 600],
	];

	const sizeMapping: IAdSlotSizeMap[] = [
		{ viewport: [0, 0], sizes: [] },
		{ viewport: [1200, 0], sizes },
	];
	const adStyles = classMerge(
		'w-full py-4 bg-neutral-grey-4 flex flex-col justify-center items-center',
		isSticky && 'sticky top-10'
	);
	const wrapperStyles = classMerge(
		'w-full flex flex-col items-center',
		isSticky && 'relative',
		className
	);

	return (
		<div className={wrapperStyles}>
			<div className={adStyles}>
				<Ad id={id} adUnit={adUnit} sizes={sizes} sizeMapping={sizeMapping} />
			</div>
		</div>
	);
};

export default SidebarAd;
